import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Inject, Output, ViewChild, ViewContainerRef, AfterViewInit, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IUserBoardComponent, UserBoardComponentMode, UserBoardComponentTypes, UserBoardItem } from 'src/app/services/models/user-board.model';
import { HeroTileComponent } from '../board-tiles/hero-tile/hero-tile.component';
import { Guid } from 'guid-typescript';
import { ChartTileComponent } from '../board-tiles/chart-tile/chart-tile.component';
import { TableTileComponent } from '../board-tiles/table-tile/table-tile.component';
import { PieTileComponent } from '../board-tiles/pie-tile/pie-tile.component';
import { ITileComponent } from '../board-tiles/common-tile.model';

export class BoardItemCreatorModalObject {
  public isEditing: boolean;
  public isCreating: boolean;
  public boardItem: UserBoardItem | null;

  constructor(isEditing: boolean, isCreating: boolean, boardItem?: UserBoardItem) {
    this.isEditing = isEditing;
    this.isCreating = isCreating;
    this.boardItem = boardItem || null;
  }
}

@Component({
  selector: 'bhub-board-item-creator',
  standalone: false,
  templateUrl: './board-item-creator.component.html',
  styleUrl: './board-item-creator.component.scss'
})
export class BoardItemCreatorComponent implements AfterViewInit {
  @ViewChild('tileHost', { read: ViewContainerRef }) tileHost!: ViewContainerRef;
  componentRef!: ComponentRef<any>;

  @Output() itemCreated = new EventEmitter<UserBoardItem>();
  @Output() itemCreationCancelled = new EventEmitter<void>();

  isEditing: boolean = false;  // Flag to toggle edit mode
  isCreating: boolean = false;  // Flag to toggle edit mode

  tileOptions: {
    label: string;
    type: UserBoardComponentTypes;
    component: Type<ITileComponent> | null;
    input: { data: any; mode: UserBoardComponentMode };
  }[] = [
    { label: 'Hero Tile', type: UserBoardComponentTypes.heroTile, component: HeroTileComponent, input: { data: null, mode: UserBoardComponentMode.Edit} }, //HeroTileComponent },
    { label: 'Pie Tile', type: UserBoardComponentTypes.pieChartTile, component: PieTileComponent, input: { data: null, mode: UserBoardComponentMode.Edit} }, //PieChartTileComponent },
    { label: 'Chart Tile', type: UserBoardComponentTypes.chartTile, component: ChartTileComponent, input: { data: null, mode: UserBoardComponentMode.Edit} }, //GraphTileComponent },
    { label: 'Table Tile', type: UserBoardComponentTypes.tableTile, component: TableTileComponent, input: { data: null, mode: UserBoardComponentMode.Edit} }, //TableTileComponent },
  ];

  selectedTileType = this.tileOptions[0].type;
  selectedTileOption = this.tileOptions[0];
  public saveErrorMessage: string = ''; // Error message to display when save fails


  constructor(
      @Inject(MAT_DIALOG_DATA) public data: BoardItemCreatorModalObject,
      private dialogRef: MatDialogRef<BoardItemCreatorComponent>,
      private resolver: ComponentFactoryResolver
  ) {
    this.isEditing = data.isEditing;
    this.isCreating = data.isCreating;
    if (data.boardItem) {
      this.selectedTileType = data.boardItem.componentType;
      const foundOption = this.tileOptions.find(t => t.type === data.boardItem.componentType);
      
      if (!foundOption) {
        console.error(`Tile type '${data.boardItem.componentType}' not found in tileOptions. Available types:`, this.tileOptions.map(t => t.type));
        this.selectedTileOption = this.tileOptions[0];
      } else {
        this.selectedTileOption = foundOption;
      }
      
      this.selectedTileOption.input.data = data.boardItem.data.data;
      this.selectedTileOption.input.mode = UserBoardComponentMode.Edit;
    }
  }

  ngAfterViewInit() {
    this.selectTileType(this.selectedTileType);
  }

  get selectedTile() {
    return this.tileOptions.find(t => t.type === this.selectedTileType);
  }

  selectTileType(type: UserBoardComponentTypes) {
    this.selectedTileType = type;
    const tile = this.tileOptions.find(t => t.type === type);
    this.selectedTileOption = tile; //JSON.parse(JSON.stringify(tile));

    if(this.tileHost) {
      this.tileHost.clear();
    }

    if (this.selectedTileOption && this.selectedTileOption.component) {
      const factory = this.resolver.resolveComponentFactory<ITileComponent>(this.selectedTileOption.component);
      this.componentRef = this.tileHost.createComponent(factory);

      // Optional: pass inputs
      this.componentRef.instance.data = this.selectedTileOption.input.data;
      this.componentRef.instance.mode = this.selectedTileOption.input.mode;
      this.componentRef.changeDetectorRef.detectChanges();
    }
  }

  validComponent(componentRef: ComponentRef<any>) {
    this.saveErrorMessage = componentRef.instance.validate();
    return this.saveErrorMessage === '';
  }

  saveTile(){
    if (this.componentRef?.instance?.model && this.validComponent(this.componentRef)) {
      const model = this.componentRef.instance.model;

      var userBoardItem = new UserBoardItem();
      userBoardItem.componentType = this.selectedTileOption.type;

      userBoardItem.data = { component: this.selectedTileOption.component, data: model, mode: UserBoardComponentMode.Preview} as IUserBoardComponent;
      userBoardItem.id = this.data.boardItem?.id || Guid.create().toString();
      
      // Preserve grid position if editing
      if (this.data.boardItem) {
        userBoardItem.cols = this.data.boardItem.cols;
        userBoardItem.rows = this.data.boardItem.rows;
        userBoardItem.x = this.data.boardItem.x;
        userBoardItem.y = this.data.boardItem.y;
      }

      this.dialogRef.close(userBoardItem);
    }
  }
}
